import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUser } from 'shared/hooks';
import { useProductState } from '../state';
import { MassActionPage } from './mass-action-page';

export function MassActionResolver() {
  const state = useProductState();
  const user = useUser();

  const selectedProducts = state.selectedProducts.value;

  if (!Boolean(selectedProducts.length) || !user) {
    return <Redirect to={ROUTES.products} />;
  }

  return <MassActionPage selectedProducts={selectedProducts} user={user} />;
}
